<style src="css/my.css" scoped></style>
<template>
  <div class="box">
    <div class="topBg"></div>
    <div class="doctorBox">
      <img :src="getImage()" alt="" class="doctorImg">
      <div class="doctorNameBox">
        <div class="name">{{ doctorInfo.doctorName }}
          <div class="level">{{ doctorInfo.doctorHospitalLevel }}</div>
        </div>
        <div class="phone">{{ doctorInfo.doctorPhone }} <span @click="to(`changePhone`)">修改</span></div>
      </div>
      <div class="leftDecorate"></div>
      <div class="rightDecorate"></div>
    </div>
    <div class="centerBox">
      <div class="centerBoxItem">
        {{ doctorInfo.honor }}
        <span>服务次数</span>
      </div>
      <div class="line"></div>
      <div class="centerBoxItem">
        {{ doctorInfo.honor }}
        <span>服务时长(时)</span>
      </div>
      <div class="line"></div>
      <div class="centerBoxItem">
        {{ doctorInfo.starRate }}
        <span>服务满意(%)</span>
      </div>
    </div>
    <div class="lastList">
      <!--            <div class="lastItem" @click="to(`news`)">-->
      <!--                <div class="lastLeft">-->
      <!--                    <div class="lastIcon last1"></div>-->
      <!--                    消息通知-->
      <!--                </div>-->
      <!--                <div class="lastRight"></div>-->
      <!--            </div>-->
      <div class="lastItem" @click="to(`feedback`)">
        <div class="lastLeft">
          <div class="lastIcon last2"></div>
          意见反馈
        </div>
        <div class="lastRight"></div>
      </div>
    </div>
    <footerBox active="4"></footerBox>
  </div>
</template>
<script>
import {getSource, getSources} from "../api"

import noMoreData from 'components/no-more-data'
import topbar from 'components/topbar'
import footerBox from 'components/footer'
import { getImage } from '@/utils'
import moment from 'moment/moment'

import {serialize} from 'utils/index'

export default {
  data() {
    return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
      EnvUrl: `https://cdn.ysqingxin.com/`,
      doctorInfo: {},
    }
  },
  components: {
    noMoreData,
    topbar,
    footerBox,
  },
  filters: {

    time(value) {
      let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
      return transTime
    },
  },
  computed: {},
  methods: {
    to(n) {
      this.$router.push(n)
    },
    async getChatDoctorInfo() {
      let data = await getSources("/bear-scale/api/chatDoctor/getChatDoctorInfo.json", {doctorId: localStorage.getItem('doctorId')});
      if (data.status === 0) {
        this.doctorInfo = data.doctorInfo
      } else {
        alert(data.msg)
      }
    },
    getImage() {
      return getImage(this.doctorInfo.doctorWorkPhoto)
    }
  },
  destroyed() {

  },
  mounted() {
    this.getChatDoctorInfo()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/my.vue